<template>
  <div>
    <card class="w-100">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="excelTable"
                  :data="$store.state.media.excelFiles"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="등록일"
            width="200">
            <template slot-scope="props">
              {{ props.row.regDate | moment('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="fileName"
            label="파일명">
          </el-table-column>
          <el-table-column
            prop="mediaCount"
            label="등록매체수">
          </el-table-column>
          <el-table-column
            label="관리"
            width="250">
            <template slot-scope="props">
              <el-button icon="el-icon-paperclip" @click="handleDownload(props.$index, props.row)">다운로드</el-button>
              <el-button type="danger" icon="el-icon-delete" @click="handleDelete(props.$index, props.row)">삭제</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <p-pagination class="pull-right"
                      v-on:input="changePage"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="$store.state.media.excelFileTotal">
        </p-pagination>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="register">엑셀 등록</el-button>
        </div>
      </el-col>
    </card>
  </div>
</template>

<script>
    import Vue from 'vue'
    import {Table, TableColumn, Button, Col} from 'element-ui'
    import VueMoment from 'vue-moment'
    import PPagination from 'src/components/UIComponents/Pagination.vue'

    Vue.use(VueMoment)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Button)
    Vue.use(Col)

    export default {
        name: "MediaExcelList",
        components: {
            PPagination
        },
        created: function () {
            this.$store.dispatch('common/setMenuTitle', "광고 통합 등록(엑셀)");
            this.changePage(1);
        },
        updated: function () {
            this.$refs.excelTable.doLayout();
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            handleDelete(index, row) {
                if(confirm("엑셀파일을 삭제하시겠습니까?")) {
                    this.$store.dispatch('media/deleteExcelFile', row.excelFileSeq);
                }
            },
            handleDownload(index, row) {
                location.href = "/api/media/excels/" + row.excelFileSeq + "/download?authorization=" + $cookies.get('id_token');
            },
            register() {
                Vue.router.push({name: 'MediaExcelRegistration'});
            },
            changePage(item) {
                let param = {
                    page: item,
                    rows: this.pagination.perPage
                };
                this.$store.dispatch('media/findAllExcelFiles', param);
            }
        },
        data() {
            return {
                pagination: {
                    perPage: 10,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                },
            }
        }
    }
</script>

<style scoped>

</style>
